import { render, staticRenderFns } from "./ContentBlockPDFViewer.vue?vue&type=template&id=24c92954&"
import script from "./ContentBlockPDFViewer.vue?vue&type=script&lang=js&"
export * from "./ContentBlockPDFViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports